import React from 'react'
import PropTypes from 'prop-types'
import Mask from 'vanilla-masker'
import classNames from 'classnames'

const Input = (props) => {
  const {
    id,
    type = 'text',
    name,
    value,
    onChange,
    onKeyPress = () => {},
    onKeyDown = () => {},
    onKeyUp = () => {},
    onBlur,
    mask,
    label,
    checked,
    disabled = false,
    minLength,
    maxLength,
    min,
    max,
    className,
    containerClassName,
    placeholder,
    bottomLabel,
    clearable,
    required = false,
  } = props

  const handleChange = (event) => {
    if (mask) {
      event.target.value = Mask.toPattern(event.target.value, mask)
    }

    onChange(event)
  }

  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(event)
    }
  }

  const handleKeyPress = (event) => {
    if (onKeyPress) {
      onKeyPress(event)
    }
  }

  const handleKeyDown = (event) => {
    if (onKeyDown) {
      onKeyDown(event)
    }
  }

  const handleKeyUp = (event) => {
    if (onKeyUp) {
      onKeyUp(event)
    }
  }

  const inputClass = classNames({
    input: type !== 'radio' && type !== 'checkbox',
  })

  const finalId = id || name

  return (
    <div className={containerClassName}>
      <input
        type={type}
        name={name}
        id={finalId}
        required={required}
        className={`${inputClass} ${className}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        checked={checked}
        disabled={disabled}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        placeholder={placeholder}
      />

      {label && (
        <label htmlFor={finalId} className='label'>
          {label}
        </label>
      )}

      {clearable && value && (
        <strong
          className='clearable-input-text'
          onClick={() => onChange({ target: { value: '' } })}
        >
          &times;
        </strong>
      )}

      {bottomLabel && <i className='bottomLabel'>{bottomLabel}</i>}
    </div>
  )
}

Input.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
  mask: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  placeholder: PropTypes.string,
  bottomLabel: PropTypes.string,
  clearable: PropTypes.bool,
}

export default Input
